// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"99fab612","453":"a5979135","732":"0f9fd2a9"}[chunkId] + ".chunk.js";
};